export const microgreensData = [
  {
    id: 2,
    name: 'Beet',
    price: 7,
    size: '1 clamshell',
    image: 'beet.jpeg',
    emoji: '🟣',
    subtitle: 'Earthy Sweet Garnish',
    ingredients: ['Earthy', 'Sweet', 'Magenta stems'],
    bullets: ['Striking color', 'Restaurant-style finish', 'Folate & antioxidants'],
    description: 'Magenta stems with an earthy-sweet flavor. The garnish that makes a plate look like a restaurant plated it.',
    nutrition: 'High in folate, potassium, and antioxidants. Contains betalains which support liver health and reduce inflammation.',
    usage: 'Sprinkle over smoothies, sandwiches, or any plate that needs an earthy-sweet accent. The magenta stems do the rest.',
    chefPairing: 'On the plate: crudo, beet salad, goat-cheese tartine, anywhere you want a magenta accent.',
    isAvailable: false
  },
  {
    id: 3,
    name: 'Sunflower',
    price: 7,
    size: '1 clamshell',
    image: 'sunflower.jpeg',
    emoji: '🌻',
    subtitle: 'Nutty & Crunchy',
    ingredients: ['Thick', 'Juicy', 'Nutty'],
    bullets: ['Crunchiest microgreen', 'Sandwiches & bowls', 'Protein & vitamin E'],
    description: 'Thick, juicy stems with a fresh, nutty flavor. The crunchiest microgreen we grow.',
    nutrition: 'Rich in protein, vitamin E, and essential fatty acids. Contains high levels of zinc and magnesium.',
    usage: 'Great in sandwiches, wraps, and as a topping for soups. Adds a satisfying crunch to any dish.',
    chefPairing: 'On the plate: poke bowls, Bloody Marys, banh mi, avocado toast crunch.',
    isAvailable: false
  },
  {
    id: 4,
    name: 'Kale',
    price: 7,
    size: '1 clamshell',
    image: 'kale.png',
    emoji: '🥗',
    subtitle: 'Tender Everyday Green',
    ingredients: ['Mild', 'Sweet', 'Tender'],
    bullets: ['No mature kale bite', 'Smoothies & sandwiches', 'Vitamins A, C, K'],
    description: 'Tender, mildly sweet leaves with none of the bite of mature kale. Disappears into a smoothie; holds up on a sandwich.',
    nutrition: 'Rich in vitamins A, C, and K, calcium, and antioxidants. Contains sulforaphane and glucosinolates that support detoxification.',
    usage: 'Drop into smoothies, fold into sandwiches, or scatter over grain bowls — the mild sweetness goes with anything.',
    chefPairing: 'On the plate: brick chicken, halibut, grain bowls, brunch greens.',
    isAvailable: false
  },
  {
    id: 5,
    name: 'Red Cabbage',
    price: 7,
    size: '1 clamshell',
    image: 'red_cabbage copy.png',
    emoji: '🥬',
    subtitle: 'Crunchy Purple Snap',
    ingredients: ['Crunchy', 'Mildly peppery', 'Vibrant'],
    bullets: ['Purple pops on plates', 'Tacos & poke bowls', 'Vitamin C & anthocyanins'],
    description: 'Crunchy purple stems with a mild peppery snap. The one to put on tacos, poke bowls, or anything that needs color.',
    nutrition: 'Packed with vitamin C, anthocyanins, and sulforaphane. Excellent source of antioxidants and anti-inflammatory compounds.',
    usage: 'Pile on tacos, top poke bowls, or use as a garnish — the purple stems pop on any plate.',
    chefPairing: 'On the plate: poke bowls, fish tacos, dragon rolls, anything that needs purple.',
    isAvailable: false
  },
  {
    id: 6,
    name: 'Broccoli',
    price: 7,
    size: '1 clamshell',
    image: 'broccoli.png',
    emoji: '🥦',
    subtitle: 'Mild & Versatile',
    ingredients: ['Mild', 'Crisp', 'Easy starter'],
    bullets: ['Raw broccoli, dialed down', 'Sandwiches & bowls', 'High in sulforaphane'],
    description: 'Tastes like raw broccoli, dialed down. High in sulforaphane and the easiest microgreen for first-timers.',
    nutrition: 'High in sulforaphane, vitamin C, and calcium. Contains powerful cancer-fighting compounds.',
    usage: 'Top sandwiches, finish pasta, or sprinkle on whatever you are making. Adds a fresh, crisp texture.',
    chefPairing: 'On the plate: nigiri tops, halibut crudo, brick chicken finish, grain bowls.',
    isAvailable: false
  },
  {
    id: 7,
    name: 'Mild Blend',
    price: 7,
    size: '1 clamshell',
    image: 'mild_blend.png',
    emoji: '🌱',
    isBlend: true,
    subtitle: 'Everyday Base Greens',
    ingredients: ['Kale', 'Broccoli', 'Cabbage'],
    bullets: ['Mild taste', 'Everyday upgrade', 'Family friendly'],
    description: 'Kale, broccoli, and cabbage together — balanced enough that picky eaters will eat it on a sandwich.',
    nutrition: 'Combines the benefits of three superfoods: high in vitamins A, C, K, calcium, and sulforaphane. Excellent for overall health and immunity.',
    usage: 'Sprinkle on sandwiches, smoothies, grain bowls, or any dish that needs a clean green finish. Mild enough for every meal.',
    chefPairing: 'On the plate: house salads, club sandwiches, plated entrées that need a clean green finish.',
    isAvailable: true
  },
  {
    id: 8,
    name: 'Breakfast Boost',
    price: 7,
    size: '1 clamshell',
    image: 'breakfast_boost.png',
    description: 'Kale, broccoli, and nutty sunflower. Made for avocado toast and breakfast bowls; the sunflower adds real crunch.',
    nutrition: 'Power-packed combination of protein, vitamins, and minerals. Contains essential fatty acids, sulforaphane, and antioxidants for sustained energy.',
    usage: 'Perfect for breakfast bowls, smoothies, and avocado toast. Adds a satisfying crunch and nutritional boost to your morning meal.',
    chefPairing: 'On the plate: avocado toast, eggs benedict, açaí bowls, brunch hash.',
    isAvailable: false
  },
  {
    id: 9,
    name: 'Peppery Power',
    price: 7,
    size: '1 clamshell',
    image: 'peppery_power.png',
    emoji: '🔥',
    isBlend: true,
    subtitle: 'Bold & Spicy Kick',
    ingredients: ['Radish', 'Arugula', 'Cabbage'],
    bullets: ['Strong flavor', 'Energizing bite', 'For bold taste lovers'],
    description: 'Radish, arugula, and cabbage. Sharp and peppery with real heat — for people who want their greens to wake them up.',
    nutrition: 'Rich in vitamin C, vitamin K, folate, glucosinolates, and anthocyanins. The radish and arugula bring sharp peppery compounds; cabbage adds anti-inflammatory anthocyanins.',
    usage: 'Perfect on fatty foods that need a counterpoint — burgers, deviled eggs, salmon, anything that needs a sharp green finish.',
    chefPairing: 'On the plate: ahi tuna, raw salmon tacos, caprese, deviled eggs, anything fatty that needs a bite.',
    isAvailable: true
  },
  {
    id: 10,
    name: 'Carrot',
    price: 7,
    size: '1 clamshell',
    image: 'carrot.png',
    emoji: '🥕',
    subtitle: 'Sweet & Lacy',
    ingredients: ['Sweet', 'Fresh', 'Earthy'],
    bullets: ['Like a young carrot', 'Soups & root veg', 'Beta-carotene & vitamin A'],
    description: 'Lacy fronds with a sweet, fresh-carrot taste. A lovely garnish on roasted vegetables or a bowl of carrot soup.',
    nutrition: 'High in beta-carotene, vitamin A, and antioxidants. Contains essential minerals for eye health.',
    usage: 'Use as a garnish on roasted vegetables, soups, and tasting plates. Adds a sweet, earthy finish.',
    chefPairing: 'On the plate: roasted carrot soup, lamb plates, root-vegetable mains, plated tasting menus.',
    isAvailable: false
  },
  {
    id: 1,
    name: 'Fenugreek',
    price: 7,
    size: '1 clamshell',
    image: 'methi.jpg',
    emoji: '🌾',
    subtitle: 'Bitter & Bold',
    ingredients: ['Earthy', 'Bitter', 'Iron-rich'],
    bullets: ['Distinctly fenugreek', 'Indian cooking staple', 'Iron, protein, fiber'],
    description: 'Distinctly fenugreek, slightly bitter. Goes straight on dal, parathas, and Indian-style omelets.',
    nutrition: 'Rich in iron, protein, and fiber. Contains compounds that support blood sugar regulation.',
    usage: 'Perfect for Indian dishes, soups, and stews. Adds a unique bitter flavor to enhance dishes.',
    chefPairing: 'On the plate: dal, methi paratha, Indian omelets, contemporary South Asian tasting menus.',
    isAvailable: true
  },
  {
    id: 11,
    name: 'Colorful Trio',
    price: 7,
    size: '1 clamshell',
    image: 'colorful_trio.png',
    emoji: '🌈',
    isBlend: true,
    subtitle: 'Crunch & Color Favorite',
    ingredients: ['Sunflower', 'Broccoli', 'Radish'],
    bullets: ['Sweet crunch', 'Best-selling mix', 'Great for tacos & bowls'],
    description: 'Sunflower, broccoli, and radish in one pack. Sweet crunch up front with a mild bite — the easy bestseller for upgrading bowls, tacos, and sandwiches.',
    nutrition: 'Combines protein and vitamin E from sunflower, sulforaphane and vitamin C from broccoli, and antioxidants from radish microgreens. A broad spread in one clamshell.',
    usage: 'Toss on grain bowls, pile on tacos, or sprinkle on whatever you are making. The sunflower brings crunch; the radish adds a clean bite.',
    chefPairing: 'On the plate: poke bowls, banh mi, taco bars, anywhere a plate needs crunch and a hint of spice.',
    isAvailable: true
  },
  {
    id: 12,
    name: 'Arugula Fusion',
    price: 7,
    size: '1 clamshell',
    image: 'arugula_fusion.png',
    emoji: '🌿',
    isBlend: true,
    subtitle: 'Gourmet Greens',
    ingredients: ['Arugula', 'Broccoli', 'Cabbage'],
    bullets: ['Peppery flavor', 'Restaurant-style', 'Elevates meals'],
    description: 'Arugula leading, broccoli and cabbage rounding it out. Peppery up front, mellow on the finish — pizza-night greens that earn their place on the plate.',
    nutrition: 'High in vitamin K, folate, and glucosinolates. Combines the peppery bite of arugula with the sulforaphane of broccoli and the anthocyanins of cabbage.',
    usage: 'Pile on pizza after it comes out of the oven, fold into pasta, or tweak any plate with lemon and olive oil.',
    chefPairing: 'On the plate: wood-fired pizza, burrata, prosciutto and melon, grilled steak finish.',
    isAvailable: true
  },
  {
    id: 13,
    name: 'Wasabi',
    price: 7,
    size: '1 clamshell',
    image: 'wasabi.png',
    emoji: '🌶️',
    subtitle: 'Sinus-Clearing Heat',
    ingredients: ['Sharp', 'Pungent', 'Clean finish'],
    bullets: ['Horseradish-like kick', 'Sushi & oyster topper', 'Use as a finishing spice'],
    description: 'Sharp, horseradish-like heat that clears your sinuses then fades clean. A pinch is enough — use them like a finishing spice.',
    nutrition: 'Rich in isothiocyanates, vitamin C, and antioxidants. Contains compounds with natural antimicrobial properties that support digestive health.',
    usage: 'Top nigiri, sashimi, deviled eggs, or roast beef sandwiches. Anywhere you want heat without the green-paste tube.',
    chefPairing: 'On the plate: nigiri tops, oysters on the half shell, beef tataki, ahi tuna stacks.',
    isAvailable: true
  },
  {
    id: 14,
    name: 'Cilantro',
    price: 7,
    size: '1 clamshell',
    image: 'cilantro.png',
    emoji: '🍃',
    subtitle: 'Bright Citrus Herb',
    ingredients: ['Citrusy', 'Fresh', 'Aromatic'],
    bullets: ['Same flavor as the herb', 'Tacos, salsa, pho', 'No chopping needed'],
    description: 'Bright, citrusy, unmistakably cilantro — same flavor as the herb, gentler in size. Goes straight on tacos and into salsa.',
    nutrition: 'Rich in vitamin K, vitamin C, and antioxidants. Contains compounds that support detoxification and provide anti-inflammatory benefits.',
    usage: 'Use in tacos, salsa, pho, guacamole, or finishing curries. Adds the same bright citrus note as the herb without chopping.',
    chefPairing: 'On the plate: street tacos, ceviche, pho, Thai noodle bowls, salsa verde.',
    isAvailable: true
  },
  {
    id: 15,
    name: 'Pea Shoots',
    price: 7,
    size: '1 clamshell',
    image: 'pea_shoots.png',
    emoji: '🫛',
    subtitle: 'Sweet Pea Crunch',
    ingredients: ['Sweet', 'Tender', 'Substantial'],
    bullets: ['Like fresh snap peas', 'Stir-fries & ramen', 'Use like lettuce'],
    description: 'Tender vines and leaves that taste like the freshest snap pea you have ever had. Sweet, crunchy, and substantial enough to use like lettuce.',
    nutrition: 'High in protein, vitamin C, folate, and fiber. Contains chlorophyll and antioxidants that support energy and immune function.',
    usage: 'Toss into stir-fries at the last second, build a bowl around them, or pile on top of ramen and dumplings.',
    chefPairing: 'On the plate: stir-fries, dumpling tops, ramen finish, spring pea soups, scallop garnish.',
    isAvailable: true
  }
];

export const scheduleData = [
  { id: 2, name: 'Beet', sowDuration: 15, harvestDuration: 2, startDate: '2024-12-12' },
  { id: 3, name: 'Sunflower', sowDuration: 10, harvestDuration: 2, startDate: '2024-12-15' },
  { id: 4, name: 'Kale', sowDuration: 10, harvestDuration: 2, startDate: '2024-12-14' },
  { id: 6, name: 'Broccoli', sowDuration: 10, harvestDuration: 2, startDate: '2024-12-14' },
  // { id: 7, name: 'Spicy Mix', sowDuration: 10, harvestDuration: 2, startDate: '2024-12-7' },
  { id: 10, name: 'Carrot', sowDuration: 21, harvestDuration: 2, startDate: '2024-12-3' },
];
